import staffers from "./staffers";
import chats from "./chats";
import groups from "./groups";
import requestAResponseFromWork from "./requestAResponseFromWork";
import contracts from "./contracts";
import ratingTeacher from "./rating-teacher";
import entranceExam from "./entrance-exam";

export default {
  namespaced: true,
  modules: {
    chats,
    staffers,
    groups,
    "request-a-response-from-work": requestAResponseFromWork,
    contracts,
    "rating-teacher": ratingTeacher,
    "entrance-exam": entranceExam,
  },
};
